import service from './service';

export const getFriendsLocation = async () => {
  const response = await service.get('/user/friends/locations');

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};

export const getVisitorLocation = async (companyId) => {
  const response = await service.get(`/user/company/${companyId}/get-location`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }
  return [];
};
